/**
 * @param {number} area - area in square meters
 * @return {string}
 */
export const displayArea = area => {
  return (area <= 999)
    ? `${area.toFixed(3)} m`
    : `${(area / (1000 * 1000)).toFixed(3)} km`;
}

/**
 * @param {number} dist - distance in meters
 * @return {string}
 */
export const displayDistance = dist => {
  return (dist <= 999)
    ? `${dist.toFixed(3)} m`
    : `${(dist / 1000).toFixed(3)} km`;
}

export const removeDuplicateGeoHashes = (geoHashArray) => {
  const uniqueGeohashes = {};
  const resultArray = [];

  for (const item of geoHashArray) {
    const geohash = item.geohash;
    if (!uniqueGeohashes.hasOwnProperty(geohash)) {
      uniqueGeohashes[geohash] = true;
      resultArray.push(item);
    }
  }
  return resultArray;
}

// no need to add all selected options to query
export const shouldAddToQuery = (arr = []) => {
  const availables = arr.filter(x => !x.disabled);
  const allChecked = availables.every(item => item.isChecked);
  const allUnchecked = availables.every(item => !item.isChecked);
  return allChecked || allUnchecked ? false : availables.filter(item => item.isChecked).map(item => item.filterName);
}

// find the center point of tooltip polygons
export const getMiddle = (prop, markers) => {
  let values = markers.map(m => m[prop]);
  let min = Math.min(...values);
  let max = Math.max(...values);
  if (prop === 'lng' && (max - min > 180)) {
    values = values.map(val => val < max - 180 ? val + 360 : val);
    min = Math.min(...values);
    max = Math.max(...values);
  }
  let result = (min + max) / 2;
  if (prop === 'lng' && result > 180) {
    result -= 360
  }
  return result;
}

export const getDashedOutline = (color) => {
  return {
    polygonLine: [],
    polygonDottedLineOne: [
      {
        icon: {
          path: "M0 0H4V2H0Z", //square path
          scale: 1,
          strokeWeight: 2,
          strokeColor: color,
        },
        offset: "0",
        repeat: "6px",
      },
      {
        icon: {
          path: "M0 0H2V1H0Z", //fill square path
          scale: 1,
          strokeWeight: 2,
          strokeColor: color,
        },
        offset: "0",
        repeat: "6px",
      },
    ],
    polygonDottedLineTwo: [
      {
        icon: {
          path: "M0 0H4V3H0Z",
          scale: 1,
          strokeWeight: 2,
          strokeColor: color,
        },
        offset: "0",
        repeat: "10px",
      },
      {
        icon: {
          path: "M0 0H2V1.5H0Z",
          scale: 1,
          strokeWeight: 2,
          strokeColor: color,
        },
        offset: "0",
        repeat: "10px",
      },
    ],
    polygonDottedLineThree: [
      {
        icon: {
          path: "M0 0H4V6H0Z",
          scale: 1,
          strokeWeight: 2,
          strokeColor: color,
        },
        offset: "0",
        repeat: "16px",
      },
      {
        icon: {
          path: "M0 0H2V3H0Z",
          scale: 1.2,
          strokeWeight: 2,
          strokeColor: color,
        },
        offset: "0",
        repeat: "16px",
      },
    ],
  };
};
